import React, { useEffect, useState } from "react";
import L from "leaflet";
import { motion } from "framer-motion";

import "leaflet/dist/leaflet.css";
import { Link, useLocation } from "react-router-dom";

import {
    Card,
    Col,
    Container,
    Row,
    CardBody,
    CardTitle,
    Label,
    Button,
    Form,
    Input,
} from "reactstrap";
import { FaInstagram, FaFacebookF, FaYoutube, FaWhatsapp } from "react-icons/fa";
import Footer from "components/VerticalLayout/Footer";

const Property = () => {

    const phoneNumber = "+919586363303";

    // Function to generate the WhatsApp URL with the current page URL
    const generateWhatsAppLink = () => {
        const currentPageURL = window.location.href; // Get the current page URL
        const message = `Hello, I'm interested in the property listed here: ${currentPageURL}`;
        return `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    };


    const whatsappNumber = "919586363303";
    const whatsappMessage = encodeURIComponent(
        `Hello, I would like to post a property. I am sharing the required details:\n\n📍 Property Location: \n🏠 Property type
 \n Built-up Year: \n📏 Area (in sq. feet): \n🖼️ Images of property \n Video of property

: \n📄 Additional Information: \n`
    );

    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
    const [userType, setUserType] = useState(""); // Stores selected "You are"

    // Handle user selection
    const handleUserType = (type) => {
        setUserType(type);
    };

    // Handle purpose selection and send WhatsApp message
    const handlePurposeSelection = (purpose) => {
        if (!userType) {
            alert("Please select 'You are' first.");
            return;
        }

        // Create WhatsApp message
        const message = `Hello, I am a ${userType}. I am here to ${purpose}.`;
        const encodedMessage = encodeURIComponent(message);
        const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;

        // Open WhatsApp link
        window.open(whatsappLink, "_blank");
    };
    useEffect(() => {
        // Dynamically load the widget script
        const script = document.createElement("script");
        script.src = "https://ocpomni.alendei.io/js/widget/mzzpadohxkpzkhtr/float.js";
        script.id = "wa-widget";
        script.setAttribute("widget-id", "aaa5le"); // works as custom attribute
        script.async = true;
        document.body.appendChild(script);

        return () => {
            // Cleanup when component unmounts
            document.body.removeChild(script);
        };
    }, []);

    return (
        <React.Fragment>
            <div className="page-content" style={{ color: "#fff", fontFamily: "'Roboto', sans-serif" }}>
                <Container fluid className="py-2">
                    <Row className="justify-content-center">
                        {/* Right Column: Form */}
                        <Col lg={6} md={12}>
                            <Card
                                style={{
                                    background: "rgba(255, 255, 255, 0.1)",
                                    border: "none",
                                    borderRadius: "15px",
                                }}
                            >
                                <CardBody>
                                    <div style={{ textAlign: "center", marginBottom: "20px" }}>
                                        <h4 style={{ fontWeight: "bold" }}>
                                            Start posting your property, it’s free
                                        </h4>
                                    </div>

                                    {/* Responsive Row Container */}
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.5 }}
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexWrap: "wrap",
                                            gap: "15px",
                                        }}
                                    >
                                        <span style={{ fontWeight: "bold", fontSize: "16px", color: "#fff" }}>
                                            Post Property through WhatsApp
                                        </span>
                                        <a href={whatsappLink} target="_blank" rel="noopener noreferrer">
                                            <motion.button
                                                whileHover={{ scale: 1.1 }}
                                                whileTap={{ scale: 0.9 }}
                                                style={{
                                                    padding: "10px 18px",
                                                    fontSize: "14px",
                                                    fontWeight: "bold",
                                                    background: "linear-gradient(135deg, #25D366, #128C7E)",
                                                    color: "#fff",
                                                    border: "1px solid #128C7E",
                                                    borderRadius: "8px",
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "8px",
                                                    transition: "all 0.3s ease",
                                                    boxShadow: "0 4px 12px rgba(19, 169, 88, 0.3)",
                                                }}
                                            >
                                                <FaWhatsapp size={20} color="#fff" />
                                                WhatsApp
                                            </motion.button>
                                        </a>
                                    </motion.div>

                                    <Form>
                                        {/* You are Section */}
                                        <div className="mb-3">
                                            <Label className="mb-2" htmlFor="property-type" style={{ color: "white" }}>
                                                You are :
                                            </Label>
                                            <div className="d-flex gap-2">
                                                {["Owner", "Agent", "Builder"].map((type) => (
                                                    <Button
                                                        key={type}
                                                        type="button"
                                                        color="outline-primary"
                                                        className={`w-100 ${userType === type ? "active" : ""}`}
                                                        style={{
                                                            borderRadius: "0.5rem",
                                                            color: "white",
                                                            backgroundColor: userType === type ? "#007bff" : "transparent",
                                                        }}
                                                        onClick={() => handleUserType(type)}
                                                    >
                                                        {type}
                                                    </Button>
                                                ))}
                                            </div>
                                        </div>

                                        {/* You are here to Section */}
                                        <div className="mb-3">
                                            <Label className="mb-2" htmlFor="property-type" style={{ color: "white" }}>
                                                You are here to :
                                            </Label>
                                            <div className="d-flex gap-2">
                                                {["Sell", "Rent / Lease", "List as PG"].map((purpose) => (
                                                    <Button
                                                        key={purpose}
                                                        type="button"
                                                        color="outline-primary"
                                                        className="w-100"
                                                        style={{ borderRadius: "0.5rem", color: "white" }}
                                                        onClick={() => handlePurposeSelection(purpose)}
                                                    >
                                                        {purpose}
                                                    </Button>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="mb-3">
                                            <Label
                                                className="mb-2"
                                                htmlFor="phone-number"
                                                style={{ color: "white" }}
                                            >
                                                Your Contact No. :
                                            </Label>
                                            <Input
                                                type="text"
                                                id="phone-number"
                                                placeholder="Enter your phone number"
                                                style={{ borderRadius: "0.5rem", color: "white" }}
                                            />
                                        </div>
                                        <div className="text-center">
                                            <Button
                                                type="button"
                                                color="success"
                                                style={{ width: "100%", borderRadius: "0.5rem" }}
                                            >
                                                Start Now
                                            </Button>
                                        </div>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>


                        {/* Left Column: Image and Features */}
                        <Col xl={6} lg={6} md={12}>
                            <Card
                                style={{
                                    background: "rgba(255, 255, 255, 0.1)",
                                    border: "none",
                                    borderRadius: "15px",
                                }}
                            >
                                <CardBody>
                                    <CardTitle
                                        className="mb-4 text-center"
                                        style={{ fontSize: "1.8rem", fontWeight: "600" }}
                                    >
                                        Sell Or Rent Property Online Faster With aiinrealestate.in
                                    </CardTitle>
                                    <ul style={{ listStyleType: 'none', padding: 0, textAlign: 'left' }}>
                                        <li style={{ marginBottom: '10px', fontSize: '1.2rem' }}>
                                            ✅ Advertise for FREE
                                        </li>
                                        <li style={{ marginBottom: '10px', fontSize: '1.2rem' }}>
                                            ✅ Get unlimited enquiries
                                        </li>
                                        <li style={{ marginBottom: '10px', fontSize: '1.2rem' }}>
                                            ✅ Get shortlisted buyers and tenants
                                        </li>
                                        <li style={{ marginBottom: '10px', fontSize: '1.2rem' }}>
                                            ✅ Assistance in co-ordinating site visits
                                        </li>
                                    </ul>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Footer */}
            <Footer />
        </React.Fragment>
    );
};

// Function to inject scripts dynamically
const injectScript = (src) => {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });
};

export default Property;
